module.exports = {
  localeName: 'nn-NO',
  momentFormat: 'DD.MM.YYYY',
};
